import * as type from 'constants/action_types/chat'

export const initialState = {
  messages: [],
  isLoadingMessages: false
}

function chat(state = initialState, action) {
  switch (action.type) {
    case type.ADD_MESSAGES:
      return {
        ...state,
        messages: [...state.messages, ...action.payload]
      }
    case type.LOADING_MESSAGES:
      return {
        ...state,
        isLoadingMessages: action.payload
      }
    case type.RESET_MESSAGES:
      return {
        ...state,
        messages: []
      }
    default:
      return state
  }
}

export default chat
